<template>
	<div class="link-container">
		<b-container>
			<b-row> 
				<b-col>
					<h5> Link #{{ number }}</h5>
				</b-col>
			</b-row>
			<b-row> 
				<b-col>
					Name <br>
					<input
						v-model="data.name"
						style="width: 100%"
						@input="handleInput"
					>
				</b-col>
			</b-row>

			<b-row> 
				<b-col>
					URL <br>
					<input
						v-model="data.url"
						style="width: 100%"
						@input="handleInput"
					>
				</b-col>
			</b-row>
			<b-row> 
				<b-col style="margin-top: 12px;">
					<b-button block style="background-color: #FFAAAA; color: #000000;" @click="remove()">
						Remove Link
					</b-button>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
export default {
    name: 'LinkInput',
    props: {
        link: {
            type: Object,
            required: false,
            default: null
        },
        index: {
            type: Number,
            required: true,
            default: -1
        }
    },
    data() {
        return {
			number: this.index + 1,
			data: this.link
		};
    },
    computed: {
    },
    watch: {
    },
    methods: {
        handleInput(event) {
            const updateData = {
                index: this.index,
                link: this.data
            }
            this.$emit('update-link', updateData);
        },
        remove() {
            this.$emit('remove-link', this.index);
        }
    },
}
</script>

<style scoped>
div.link-container {
    border-radius: 6px;
	border-color: #000000;
    border-width: 2px;
    margin-top: 12px;
	background-color: #FFFFFF;
}
</style>
